function normalize(value) {
    return String(value || '').toLocaleLowerCase('ru').replace(/ё/g, 'е').trim().replace(/\s+/g, ' ');
}

function searchIndex(lines) {
    return lines.map(line => ({line, name: normalize(line.employee_name_snapshot)}));
}

function filterIndex(index, query) {
    const words = normalize(query).split(' ').filter(Boolean);
    return index.filter(item => words.every(word => item.name.includes(word))).map(item => item.line);
}

module.exports = {normalize, searchIndex, filterIndex};
